// extracted by mini-css-extract-plugin
export var correct = "quote-module--correct--yvxxz";
export var quote = "quote-module--quote--k-vuj";
export var wrong = "quote-module--wrong--0Mz8I";